import { BREAKPOINT_SMALL } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

const getBookingEngineLabelColour = (highlighted: boolean) => {
  return highlighted ? 'white' : '#dcdcdc'
}
const getExozLabelColour = (highlighted: boolean) => {
  return highlighted ? 'var(--brand-secondary)' : '#7D5B19'
}

const getBookingEngineStepColour = (highlighted: boolean) => {
  return highlighted ? 'white' : '#dcdcdc'
}
const getExozStepColour = (highlighted: boolean) => {
  return highlighted ? 'white' : '#ffdc75'
}

const getBrandPrimaryColour = (isBookingEngine: boolean) => {
  return isBookingEngine ? 'transparent' : 'var(--brand-primary)'
}

const getActiveIconColour = (isBookingEngine: boolean) => {
  return isBookingEngine ? 'transparent' : 'var(--brand-secondary)'
}
const getActiveCompleteColour = (isBookingEngine: boolean) => {
  return isBookingEngine ? 'transparent' : 'var(--brand-primary)'
}

export const Step = styled.div<{ complete: boolean; bookingEngine: boolean }>`
  width: calc(100% / 3);
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 6px;
  position: relative;
  z-index: 1;

  &:not(:last-child)::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    left: calc(50% + 20px);
    top: 5px;
    width: calc(100% - 40px);
    transform: translateY(-50%);
    height: 3px;
    background: ${({ complete, bookingEngine }) =>
      bookingEngine ? getBookingEngineStepColour(complete) : getExozStepColour(complete)};
  }
`
export const Label = styled.span<{ active: boolean; complete: boolean; bookingEngine: boolean }>`
  text-align: center;
  display: block;
  font-weight: var(--font-medium);
  font-size: 12px;
  line-height: 1;
  color: ${({ active, bookingEngine }) =>
    bookingEngine ? getBookingEngineLabelColour(active) : getExozLabelColour(active)};
`
export const IconWrapper = styled.div<{ active: boolean; complete: boolean; bookingEngine: boolean }>`
  background: var(--brand-primary);
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  width: 40px;
  height: 40px;
  background: ${({ complete, active, bookingEngine }) =>
    complete || active ? 'white' : getBrandPrimaryColour(bookingEngine)};
  box-shadow: inset 0 0 0 3px
    ${({ active, complete, bookingEngine }) =>
      bookingEngine ? getBookingEngineStepColour(active || complete) : getExozStepColour(active || complete)};

  svg {
    width: 18px;
    height: 18px;
    color: white;
    color: ${({ complete, active, bookingEngine, theme }) =>
      (active &&
        !bookingEngine &&
        `
        var(--brand-secondary);
      `) ||
      (complete &&
        !bookingEngine &&
        `
        var(--brand-primary)`) ||
      (active &&
        bookingEngine &&
        `
        #9a9a9a;
      `) ||
      (complete && bookingEngine && theme?.colourPalette?.primaryColour)};
  }
`
export const StepContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 48px;
  width: 300px;
  margin: 0 auto;
`

export const Wrapper = styled.div`
  background: ${({ theme }) => theme?.colourPalette?.primaryColour || 'var(--brand-primary)'};
  padding: 20px 0;
  width: 100%;

  ${StepContainer} {
    width: 100%;
    height: auto;
    justify-content: space-between;
  }
  ${Step} {
    &:not(:last-child)::before {
      top: 20px;
      height: 3px;
    }
  }
  ${Label} {
    font-size: 14px;
    font-weight: var(--font-bold);
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    ${Step} {
      width: calc(calc(100% / 3) - 30px);

      &:not(:last-child)::before {
        width: calc(100% + 5px);
      }
    }
    ${Label} {
      font-size: 12px;
    }
  }
`
